import React, { ReactNode } from "react";
import { Platform, StyleSheet, View, ViewStyle } from "react-native";
import { LinearGradient } from "expo-linear-gradient";

const GRADIENT_COLORS = [
  "rgba(255, 223, 212, 0.40)",
  "rgba(204, 0, 0, 0.30)",
] as const;

/** CSS `linear-gradient(241deg, …)` — matches design spec for web. */
const WEB_GRADIENT =
  "linear-gradient(241deg, rgba(255, 223, 212, 0.40) 0%, rgba(204, 0, 0, 0.30) 100%)";

/** Approximate 241deg for `expo-linear-gradient` on native. */
const NATIVE_GRADIENT_START = { x: 0.15, y: 0 };
const NATIVE_GRADIENT_END = { x: 0.85, y: 1 };

type GradientColoredProps = {
  children?: ReactNode;
  style?: ViewStyle | ViewStyle[];
  testID?: string;
};

export default function GradientColored({
  children,
  style,
  testID,
}: GradientColoredProps) {
  if (Platform.OS === "web") {
    return (
      <View style={[styles.container, styles.containerWeb, style]} testID={testID}>
        {children}
      </View>
    );
  }

  return (
    <LinearGradient
      colors={[...GRADIENT_COLORS]}
      locations={[0, 1]}
      start={NATIVE_GRADIENT_START}
      end={NATIVE_GRADIENT_END}
      style={[styles.container, style]}
      testID={testID}
    >
      {children}
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    alignItems: "center",
    alignSelf: "stretch",
    height: 32,
    padding: 0,
    gap: 4,
  },
  containerWeb: {
    ...(Platform.OS === "web"
      ? ({
          backgroundImage: WEB_GRADIENT,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        } as any)
      : {}),
  },
});
